export var MESSAGE_TYPES = {
  // generic types, for identifying source of message
  IFRAME_MESSAGE: 'sumup-subscriptions-iframe-message',
  WIDGET_MESSAGE: 'sumup-subscriptions-widget-message',
  // specific types, for handling specific tasks
  CARD_AUTHENTICATION_START: 'card-authentication-start',
  CARD_AUTHENTICATION_FINISH: 'card-authentication-finish',
  ALIGN_OFFSET: 'widget-offset-alignment',
  ON_ERROR: 'widget-on-error',
  ON_SUCCESS: 'widget-on-success',
  ON_RESIZE: 'widget-on-resize',
  ON_LOAD: 'widget-on-load',
  ON_SCROLL_TOP: 'widget-on-scroll-top',
  LEGAL_INFO: 'legal-info',
  TRACE_EVENT: 'trace-event',
  BUSINESS_ACCOUNT: 'business-account'
};
export var EPAY_ERROR_CODES = {
  UNSUPPORTED_FREQUENCY: 'OP-EP-SE-120'
};
export var COUPON_INVALID_TYPES = {
  INVALID_CODE: 'invalid_code',
  UNSUPPORTED_FREQUENCY: 'unsupported_frequency'
};
export var SCA_MODAL_EVENTS = {
  USER_INTERRUPTED: 'sca-user-interrupted',
  MISSING_PARAMETER: 'sca-missing-parameter'
};
export var TRACING_EVENTS = {
  // Billing flow success
  PURCHASE_ATTEMPTED: 'purchase-attempted',
  SUBSCRIPTION_PURCHASED: 'subscription-purchased',
  PAYMENT_METHOD_UPDATED: 'payment-method-updated',
  BILLING_DETAILS_UPDATED: 'billing-details-updated',
  PAYMENT_METHOD_VERIFICATION_COMPLETE: 'payment-method-verification-complete',
  // Billing flow error
  PURCHASE_FAILED: 'purchase-failed',
  BILLING_DETAILS_UPDATE_FAILED: 'billing-details-update-failed',
  PAYMENT_METHOD_UPDATE_FAILED: 'payment-method-update-failed',
  PAYMENT_METHOD_VERIFICATION_FAILED: 'payment-method-verification-failed',
  // HTTP communication errors
  SUMUP_REQUEST_BLOCKED: 'sumup-request-blocked',
  BILLING_SERVICE_UNAVAILABLE: 'billing-service-unavailable',
  SERVER_ERROR: 'server-error',
  // 3DS events
  SCA_VERIFICATION_STARTED: 'sca-verification-started',
  SCA_MODAL_OPENED: 'sca-modal-opened',
  SCA_MODAL_CLOSED: 'sca-modal-closed',
  SCA_VERIFICATION_FAILED: 'sca-verification-failed',
  SCA_VERIFICATION_FINISHED: 'sca-verification-finished',
  // ePay events
  EPAY_CARD_VERIFIED: 'epay-card-verified',
  EPAY_CARD_VERIFICATION_FAILED: 'epay-card-verification-failed',
  // Sumup Subscriptions events
  SUMUP_SUBSCRIPTIONS_SERVICE_UNAVAILABLE: 'sumup-subscriptions-service-unavailable',
  // Merchant Wallet events
  MERCHANT_WALLET_SERVICE_UNAVAILABLE: 'merchant-wallet-service-unavailable'
};